import {colors} from "@c10h/colors";
import NextImage from "@components/NextImage";
import Link from "next/link";
import {useTranslation} from "@i18n/client";
import React from "react";

import {SpecialtyId} from "../../../constants/specialtyIds";
import {getSchedulingRedirectUrl} from "../../../utils/getRedirectUrl";
import {v5Pages, vcData} from "../../_common/_constants";
import {trackToPatient} from "../../_common/Carbon";
import {Btn} from "../V5Comp";
import styles from "./Hero.module.scss";

const Hero = ({pathname, currentSpecialtyId}: {pathname: string; currentSpecialtyId: string}) => {
  const i18n = useTranslation();

  const schedulingUrl = getSchedulingRedirectUrl({
    virtual: true,
    specialtyId: currentSpecialtyId,
  });

  const clickHandler = (): void => {
    trackToPatient({ga: {label: "Virtual Care"}});
  };

  const Button = (
    <Btn bg={colors.darkerMint} href={schedulingUrl} onClick={clickHandler}>
      {i18n.t("Book appointment")}
    </Btn>
  );

  const renderInner = () => {
    if (currentSpecialtyId === SpecialtyId.VIRTUAL_MENTAL_HEALTH) {
      return (
        <div className={styles.innerInner}>
          <div className={styles.r1}>
            <h1
              className={styles.r1_c2}
              style={{color: vcData[currentSpecialtyId].darker2, textShadow: "none"}}
            >
              {i18n.t("Introducing virtual Mental Health")}
            </h1>
          </div>
          <strong className={styles.r2} style={{color: colors.gray800, textShadow: "none"}}>
            {i18n.t("Virtual mental health sessions. Wherever you are.")}
          </strong>
          <div className={styles.r4}>{Button}</div>
        </div>
      );
    }
    return (
      <div className={styles.innerInner}>
        <div className={styles.r1}>
          <h1 className={styles.r1_c2}>{i18n.t("Introducing virtual everyday care")}</h1>
        </div>
        <strong className={styles.r2}>{i18n.t("Same excellent care. Wherever you are.")}</strong>
        <div className={styles.r3}>
          {i18n.t("Get treated for a range of symptoms & conditions right from your smartphone.")}
        </div>
        <div className={styles.r4}>{Button}</div>
      </div>
    );
  };
  return (
    <div className={`mt18 ${styles.outerWrap}`}>
      <div className={styles.wrap}>
        <div className={styles.inner}>{renderInner()}</div>

        <div className={`${styles.inner} ${styles.lmWrap}`}>
          <a
            href="#servicesWrap"
            className={`${styles.lm} ${
              currentSpecialtyId === SpecialtyId.VIRTUAL_MENTAL_HEALTH ? "darkerPurple-f" : ""
            }`}
          >
            <span className={`cIcon-mouse ${styles.lm_c1}`} aria-hidden />
            <span className={styles.lm_c2}>{i18n.t("Learn more")}</span>
          </a>
        </div>
        <div style={{height: 300}} className="relative block md:hidden">
          <NextImage
            objectFit="cover"
            objectPosition="0 100%"
            src="/vcHeroMobile"
            layout="fill"
            alt=""
          />
        </div>
      </div>
      <div className={styles.tabs}>
        {[
          {
            title: "Everyday Virtual Care",
            icon: "elb-pain",
            color: vcData[SpecialtyId.VIRTUAL_URGENT_CARE].darker,
            bgColor: vcData[SpecialtyId.VIRTUAL_URGENT_CARE].color,
            href: {
              pathname: v5Pages.virtualCare,
            },
          },
          {
            title: "Virtual Mental Health",
            icon: "establish-non-physical",
            color: vcData[SpecialtyId.VIRTUAL_MENTAL_HEALTH].darker,
            bgColor: vcData[SpecialtyId.VIRTUAL_MENTAL_HEALTH].color,
            href: {
              pathname: v5Pages.virtualCareMental,
            },
          },
        ].map(t => (
          <Link
            key={t.icon}
            href={t.href}
            className={`${styles.tab} ${t.href.pathname === pathname ? styles.active : ""}`}
            style={{"--color": t.color, "--bgColor": t.bgColor}}
          >
            <>
              <span className={`${styles.tab_icon} cIcon-${t.icon}`} aria-hidden />
              <span className={styles.tab_title}>{t.title}</span>
            </>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Hero;
